/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useState } from 'react';
import './Footer.scss'
import { Modal } from "react-bootstrap";
import Button from '../controls/buttons/button';
import { useTranslation } from 'react-i18next';
import ReglamentoDeComerciantes from './ReglamentoDeComerciantes';
import TermsAndContions from './TermsAndCondition';
import { WebCache } from '../../services/WebCache';
import {ReactComponent as ARGFlag } from "itd-common/assets/icons/flag-arg.svg";
import {ReactComponent as UYUFlag } from "itd-common/assets/icons/flag-uyu.svg";
import { UtilService } from '../../services/UtilService';
import {ReactComponent as LogoFiserv} from "itd-common/assets/images/brand/logoFiservBlack.svg";
import PersonalData from './PersonalData';

interface IState {
    isValid: boolean;
}

const URUGUAY= "UYU";
const ARGENTINA= "ARG";
const T_PREFIX: string = 'pages.footer.';

const LoggedInFooter: React.FC = () => {
    const countryUserLogged: string = WebCache.isUserUYU()? "Uruguay" : "Argentina";
        
    return (
        <div className="w-100 h-100 text-center position-relative">
            <div className="divLine w-100">
                <div className="divLine__line"></div>
            </div>
            <div className="logoFooter">
                <LogoFiserv />
            </div>
            <div className="w-100 h-100 textContainer">
                <div className="d-flex textContainer__into">
                    <div className="textContainer__into__text ">First Data {countryUserLogged} S.R.L. | Todos los derechos reservados</div>
                </div>
            </div>
        </div>
    );
};

const LoggedOutFooter: React.FC = () => {
    const { t } = useTranslation();
    const [hiddenSelectCountry, sethiddenSelectCountry] = useState<Boolean>(false); 
    const [showTermsAndConditionsModal, setShowTermsAndConditionsModal] = useState<boolean>(false);
    const [showPersonalDataProtectionModal, setShowPersonalDataProtectionModal] = useState<boolean>(false);
    const [showMerchantRegulationsModal, setShowMerchantRegulationsModal] = useState<boolean>(false);
    const [country, setCountry] = useState<string>(URUGUAY);

    const openTermsAndConditionsModal = () => {
        setCountry(URUGUAY);
        setShowTermsAndConditionsModal(true);
    };

    const openPersonalDataProtectionModal = () => {
        setCountry(URUGUAY);
        setShowPersonalDataProtectionModal(true);
    };

    const openMerchantRegulationsModal = () => {
        setCountry(URUGUAY);
        setShowMerchantRegulationsModal(true);
    };

    const closeTermsAndConditionsModal = () => {
        setShowTermsAndConditionsModal(false);
    };

    const closePersonalDataProtectionModal = () => {
        setShowPersonalDataProtectionModal(false);
    };

    const closeMerchantRegulationsModal = () => {
        setShowMerchantRegulationsModal(false);
    };

    return (
        <>
            <div className="w-100 h-100 text-center position-relative footerRou">
                <div className="group">
                    <div className="group__text">
                        <div className="group__text__links">
                            <div className="group__text__links__a">
                                <LogoFiserv  className='w-75'/>
                            </div>
                            <div className="group__text__links__a"><a onClick={openMerchantRegulationsModal} className='group__text__links__a__color cursor-pointer'>{t(`${T_PREFIX}merchantRegulations`)}</a></div>
                            <div className="group__text__links__a"><a onClick={openTermsAndConditionsModal} className='group__text__links__a__color cursor-pointer'>{t(`${T_PREFIX}termsAndConditions`)} </a></div>
                            <div className="group__text__links__a"><a onClick={openPersonalDataProtectionModal} className='group__text__links__a__color cursor-pointer'>{t(`${T_PREFIX}protectionOfPersonalData`)} </a></div>
                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                    <div className='group__text__links__a'>
                                        <a onClick={() => sethiddenSelectCountry(!hiddenSelectCountry)} className='group__text__links__a__color cursor-pointer'>
                                            {t(`${T_PREFIX}aboutFiserv`)}
                                        </a>
                                    </div>
                                    <div className={`select-country ${!hiddenSelectCountry ? "hidden" : ""}`}>
                                        <a href='https://www.fiserv.com.uy/' target='_blank' rel="noopener noreferrer">
                                        <span className='pe-2'><UYUFlag/> </span>
                                        </a>
                                        <a href='https://www.fiserv.com.ar/' target='_blank' rel="noopener noreferrer">
                                        <span><ARGFlag/> </span>
                                        </a>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-100 position-absolute d-flex textContainer">
                    <div className="w-100 textContainer__into">
                        <div className="textContainer__into__text">{t(`${T_PREFIX}copyright`)}</div>
                    </div>
                </div>
            </div>
            <Modal show={showMerchantRegulationsModal} dialogClassName="footer-modal" >
                <div className="modal-content modal-content-demo">
                    <div className="modal-header bg-primary align-items-center">
                        <a {...(UtilService.isMobilePlatform() ? {}: { type: 'button' } )}
                        onClick={() => setCountry(URUGUAY)}>
                            <h4 className="modal-title text-white">{t(`${T_PREFIX}merchantRegulations`)} - <UYUFlag></UYUFlag>  </h4>
                        </a>
                        <div className='divider'></div>
                        <a {...(UtilService.isMobilePlatform() ? {}: { type: 'button' } )}
                        onClick={() => setCountry(ARGENTINA)}>
                            <h4 className="modal-title text-white">{t(`${T_PREFIX}merchantRegulations`)} - <ARGFlag></ARGFlag></h4>
                        </a>
                        <Button aria-label="Close" className="btn-close p-0" onClick={() => closeMerchantRegulationsModal()} noBlock >
                            <span className='text-white' aria-hidden="true">&times;</span>
                        </Button>
                    </div>
                    <div className="modal-body">
                        <div className="scrollable-container">
                            <ReglamentoDeComerciantes country={country}/>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <Button onClick={() => closeMerchantRegulationsModal()} noBlock >
                            <span className='text-white' aria-hidden="true">{t(`close`)}</span>
                        </Button>
                    </div>
                </div>
            </Modal>
            <Modal show={showTermsAndConditionsModal} dialogClassName="footer-modal" >
                <div className="modal-content modal-content-demo">
                    <div className="modal-header bg-primary align-items-center">
                        <a {...(UtilService.isMobilePlatform() ? {}: { type: 'button' } )}
                        className='me-3' onClick={() => setCountry(URUGUAY)}>
                            <h4 className="modal-title text-white">{t(`${T_PREFIX}termsAndConditions`)} <UYUFlag></UYUFlag></h4>
                        </a>
                        <div className='divider'></div>
                        <a {...(UtilService.isMobilePlatform() ? {}: { type: 'button' } )}
                        className='ms-3' onClick={() => setCountry(ARGENTINA)}>
                            <h4 className="modal-title text-white">{t(`${T_PREFIX}termsAndConditions`)} <ARGFlag></ARGFlag></h4>
                        </a>
                        <Button aria-label="Close" className="btn-close p-0" onClick={() => closeTermsAndConditionsModal()} noBlock >
                            <span className='text-white' aria-hidden="true">&times;</span>
                        </Button>
                    </div>
                    <div className="modal-body">
                        <div className="scrollable-container w-95">
                            <TermsAndContions country={country} />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <Button onClick={() => closeTermsAndConditionsModal()} noBlock >
                            <span className='text-white' aria-hidden="true">{t(`close`)}</span>
                        </Button>
                    </div>
                </div>
            </Modal>
            <Modal show={showPersonalDataProtectionModal} title={t(`protectionOfPersonalData`)} dialogClassName="footer-modal" >
                <div className="modal-content modal-content-demo">
                    <div className="modal-header bg-primary align-items-center">
                        <a {...(UtilService.isMobilePlatform() ? {}: { type: 'button' } )}
                        className='me-3' onClick={() => setCountry(URUGUAY)}>
                            <h4 className="modal-title text-white">{t(`${T_PREFIX}protectionOfPersonalData`)} <UYUFlag></UYUFlag></h4>
                        </a>
                        <div className='divider'></div>
                        <a {...(UtilService.isMobilePlatform() ? {}: { type: 'button' } )}
                        className='ms-3' onClick={() => setCountry(ARGENTINA)}>
                            <h4 className="modal-title text-white">{t(`${T_PREFIX}protectionOfPersonalData`)} <ARGFlag></ARGFlag></h4>
                        </a>
                        <Button aria-label="Close" className="btn-close p-0" onClick={() => closePersonalDataProtectionModal()} noBlock >
                            <span className='text-white' aria-hidden="true">&times;</span>
                        </Button>
                    </div>
                    <PersonalData country={country} />
                    <div className="modal-footer">
                        <Button onClick={() => closePersonalDataProtectionModal()} noBlock >
                            <span className='text-white' aria-hidden="true">{t(`close`)}</span>
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

const Footer: React.FC<IState> = ({ isValid }) => {
    return (
        <>
        {isValid ? < LoggedInFooter/> : <LoggedOutFooter />}
        </>
    );
};

export default Footer;